import '@angular/compiler';
import { PagePosSalesReceiptComponent } from './page.pos.sales.receipt/page.pos.sales.receipt.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PagePosSalesMenuComponent } from './page.pos.sales.menu/page.pos.sales.menu.component';
import { PageStartComponent } from './page.start/page.start.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PagePosBusinessComponent } from './page.pos.business/page.pos.business.component';
import { PagePosSettingsComponent } from './page.pos.settings/page.pos.settings.component';
import { PagePosSalesStatusComponent } from './page.pos.sales.status/page.pos.sales.status.component';
import { PagePosOrdersComponent } from './page.pos.orders/page.pos.orders.component';
import { LayoutPosComponent } from './layout.pos/layout.pos.component';
import { PagePosSalesComponent } from './page.pos.sales/page.pos.sales.component';
import { PagePosCustomerComponent } from './page.pos.customer/page.pos.customer.component';
import { PagePosRevenueComponent } from './page.pos.revenue/page.pos.revenue.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PagePosComponent } from './page.pos/page.pos.component';

const INDEX_PAGE = "start";
const POS_ROUTE_DEBUG_VERSION = "20260507-pos-customer-debug1";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutPosComponent,
        "children": [
            {
                "path": "pos/sales/receipt",
                component: PagePosSalesReceiptComponent,
                "app_id": "page.pos.sales.receipt"
            },
            {
                "path": "pos/sales/menu",
                component: PagePosSalesMenuComponent,
                "app_id": "page.pos.sales.menu"
            },
            {
                "path": "pos/business",
                component: PagePosBusinessComponent,
                "app_id": "page.pos.business"
            },
            {
                "path": "pos/settings",
                component: PagePosSettingsComponent,
                "app_id": "page.pos.settings"
            },
            {
                "path": "pos/sales/status",
                component: PagePosSalesStatusComponent,
                "app_id": "page.pos.sales.status"
            },
            {
                "path": "pos/orders",
                component: PagePosOrdersComponent,
                "app_id": "page.pos.orders"
            },
            {
                "path": "pos/sales",
                component: PagePosSalesComponent,
                "app_id": "page.pos.sales"
            },
            {
                "path": "pos/customer",
                component: PagePosCustomerComponent,
                "app_id": "page.pos.customer"
            },
            {
                "path": "pos/revenue",
                component: PagePosRevenueComponent,
                "app_id": "page.pos.revenue"
            },
            {
                "path": "pos",
                component: PagePosComponent,
                "app_id": "page.pos"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "start",
                component: PageStartComponent,
                "app_id": "page.start"
            }
        ]
    }
];
let debugRoute = (label: string, payload: any = {}) => {
    console.log(`[POS-ROUTE-DEBUG][${POS_ROUTE_DEBUG_VERSION}] ${label}`, payload);
}

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();
debugRoute('routing-module:init', {
    href: window.location.href,
    pathname: window.location.pathname,
    appRouteLayouts: app_routes.length,
    appRoutes: app_routes.map((layout: any, index: number) => ({
        index,
        component: layout.component?.name || '',
        children: (layout.children || []).map((child: any) => child.path)
    }))
});

let patternMatcher = (pattern: any, url: any) => {
    let originalPattern = pattern;
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;
        if (window.WizRoute.path === 'pos/customer' || originalPattern === 'pos/customer') {
            debugRoute('patternMatcher:matched', { originalPattern, wizRoute: window.WizRoute });
        }

        return { consumed: url, posParams: posParams };
    }
    if (originalPattern === 'pos/customer' || window.location.pathname === '/pos/customer') {
        debugRoute('patternMatcher:not-matched', { originalPattern, incoming: url.map((x: any) => x.path).join('/'), pathname: window.location.pathname });
    }
    return null
}

let exactMatcher = (paths: string[]) => {
    return (url: any) => {
        let urlpath = url.map((x: any) => x.path).join("/");
        debugRoute('exactMatcher:check', { paths, urlpath, pathname: window.location.pathname });
        if (paths.includes(urlpath)) {
            window.WizRoute.path = urlpath;
            window.WizRoute.segment = {};
            debugRoute('exactMatcher:matched', { urlpath, wizRoute: window.WizRoute });
            return { consumed: url, posParams: {} };
        }
        return null;
    }
}

let customerFallbackMatcher = (url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let pathname = window.location.pathname.replace(/^\//, '');
    debugRoute('customerFallbackMatcher:check', { urlpath, pathname, href: window.location.href });
    if (urlpath === 'pos/customer' || urlpath === 'customer' || pathname === 'pos/customer') {
        window.WizRoute.path = 'pos/customer';
        window.WizRoute.segment = {};
        debugRoute('customerFallbackMatcher:matched', { urlpath, pathname, wizRoute: window.WizRoute });
        return { consumed: url, posParams: {} };
    }
    return null;
}

let findAppRoute = (path: string) => {
    for (let i = 0; i < app_routes.length; i++) {
        let layout: any = app_routes[i];
        let layout_childs = layout.children || [];
        for (let j = 0; j < layout_childs.length; j++) {
            let child = layout_childs[j];
            if (child.path === path) return child;
        }
    }
    return null;
}

let routes: Routes = [];
let customerRoute: any = findAppRoute("pos/customer");
debugRoute('customerRoute:resolved', { found: !!customerRoute, component: customerRoute?.component?.name || '' });

if (customerRoute) {
    routes.push({
        matcher: customerFallbackMatcher,
        component: customerRoute.component
    });
    routes.push({
        matcher: exactMatcher(['pos/customer', 'customer']),
        component: customerRoute.component
    });
    routes.push({
        path: 'customer',
        component: customerRoute.component
    });
}

routes.push({
    matcher: (url: any) => {
        let urlpath = url.map((x: any) => x.path).join("/");
        debugRoute('redirectGuard:check', { urlpath, pathname: window.location.pathname });
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        debugRoute('redirectGuard:redirecting', { urlpath, redirectTo: INDEX_PAGE });
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
});

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

if (customerRoute) {
    routes.push({
        path: '**',
        component: customerRoute.component
    });
}

debugRoute('routes:final', routes.map((route: any, index: number) => ({
    index,
    path: route.path || '',
    hasMatcher: !!route.matcher,
    redirectTo: route.redirectTo || '',
    component: route.component?.name || '',
    childCount: route.children?.length || 0
})));

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
